import { render, screen } from "@testing-library/react";
import PageTitle from "./PageTitle";

test("check rendering page title", () => {
  render(<PageTitle level={1} title="Page title" />);
  expect(screen.getByText("Page title")).toBeInTheDocument();
});
